<template>
    <vx-card id="loader">
        <h3>Топы EPC</h3>

        <vs-button class="mt-2" color="success" @click="createTop()" type="filled"> Добавить топ </vs-button>

        <div class="vx-row mt-3 mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input
                        v-model="form.name"
                        autocomplete="off"
                        label="Поиск по названию"
                        placeholder="Введите название..."
                        class="mt-1 w-full"
                    />
                </div>
            </div>
        </div>

        <div class="vx-row mb-2">
            <div class="vx-col w-1/2 mb-1">
                <div class="vx-row">
                    <div class="mt-1 w-5/6 vx-col">
                        <label class="vs-input--label"> Платформы </label>
                        <v-select
                            multiple
                            :options="dicts.deviceTypes"
                            @input="setSelected(form.deviceTypes, 'deviceTypes')"
                            label="name"
                            placeholder="Выберите платформы"
                            class="w-full"
                            v-model="form.deviceTypes"
                        >
                        </v-select>
                    </div>
                    <div class="pt-3">
                        <vx-tooltip text="Очистить список" position="top" delay=".3s">
                            <feather-icon
                                icon="XIcon"
                                @click="form.deviceTypes = []"
                                class="inline-block text-danger cursor-pointer"
                                svgClasses="w-5 h-5"
                            />
                        </vx-tooltip>
                    </div>
                </div>
            </div>

            <div class="vx-col w-1/2 mb-1">
                <div class="vx-row">
                    <div class="mt-1 w-5/6 vx-col">
                        <label class="vs-input--label"> Страны </label>
                        <v-select
                            multiple
                            @input="setSelected(form.countries, 'countries')"
                            :options="dicts.countries"
                            label="name"
                            placeholder="Выберите страны"
                            class="w-full"
                            v-model="form.countries"
                        >
                        </v-select>
                    </div>
                    <div class="pt-3">
                        <vx-tooltip text="Очистить список" position="top" delay=".3s">
                            <feather-icon
                                icon="XIcon"
                                @click="form.countries = []"
                                class="inline-block text-danger cursor-pointer"
                                svgClasses="w-5 h-5"
                            />
                        </vx-tooltip>
                    </div>
                </div>
            </div>
        </div>

        <vs-button class="mt-2" color="warning" @click="loadTops()" type="filled"> Применить </vs-button>

        <vs-table stripe :data="tops" class="mt-5 mb-3">
            <template slot="header"> </template>
            <template slot="thead">
                <vs-th> Id </vs-th>
                <vs-th> Название </vs-th>
                <vs-th> Лидов для реального EPC </vs-th>
                <vs-th> Дней для реального EPC </vs-th>
                <vs-th> Дней для потенциального EPC </vs-th>
                <vs-th> Максимальный EPC </vs-th>
                <vs-th> Страны </vs-th>
                <vs-th> Платформы </vs-th>
                <vs-th> Действия </vs-th>
            </template>

            <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>
                        {{ tr.id }}
                    </vs-td>
                    <vs-td class="vs-lg-4">
                        <router-link :to="{ name: 'epc-edit', params: { id: tr.id } }">
                            {{ tr.name }}
                        </router-link>
                    </vs-td>
                    <vs-td>
                        {{ tr.leadsAmount }}
                    </vs-td>
                    <vs-td>
                        {{ tr.periodEpc }}
                    </vs-td>
                    <vs-td>
                        {{ tr.periodPotentialEpc }}
                    </vs-td>
                    <vs-td>
                        {{ tr.maxEpc }}
                    </vs-td>
                    <vs-td>
                        <ul>
                            <li :key="country.id" v-for="country in checkAllSelection(dicts.countries, tr.countries)">{{ country.name }}</li>
                        </ul>
                    </vs-td>
                    <vs-td>
                        <ul>
                            <li :key="deviceType.id" v-for="deviceType in checkAllSelection(dicts.deviceTypes, tr.deviceTypes)">
                                {{ deviceType.name }}
                            </li>
                        </ul>
                    </vs-td>
                    <vs-td class="actions">
                        <div class="inline-block">
                            <router-link :to="{ name: 'epc-edit', params: { id: tr.id } }">
                                <vx-tooltip text="Редактировать топ">
                                    <feather-icon icon="Edit2Icon" class="inline-block mr-2" svgClasses="w-7 h-7" />
                                </vx-tooltip>
                            </router-link>
                        </div>
                        <div class="inline-block">
                            <router-link :to="{ name: 'epc-coeffs', params: { id: tr.id } }">
                                <vx-tooltip text="Коэффициенты часа">
                                    <feather-icon icon="ClockIcon" class="inline-block mr-2 text-warning" svgClasses="w-7 h-7" />
                                </vx-tooltip>
                            </router-link>
                        </div>
                        <div class="inline-block cursor-pointer">
                            <vx-tooltip text="Удалить топ" position="top" delay=".3s">
                                <feather-icon
                                    @click="showDeleteModal(tr)"
                                    icon="XCircleIcon"
                                    class="inline-block mr-2 text-danger"
                                    svgClasses="w-7 h-7"
                                />
                            </vx-tooltip>
                        </div>
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>

        <vs-pagination :max="5" :total="pagesTotal" v-model="page"></vs-pagination>

        <sweet-modal ref="deleteModal" icon="error" title="Удаление топа">
            <div class="mb-5">Вы действительно хотите удалить топ {{ selected.name }}?</div>

            <vs-button class="" color="danger" @click="deleteTop(selected)" type="filled"> Удалить топ </vs-button>
        </sweet-modal>
    </vx-card>
</template>

<script>
import { SweetModal, SweetModalTab } from 'sweet-modal-vue';
import vSelect from 'vue-select';
import axios from 'axios';
import qs from 'qs';

export default {
    name: 'epc',
    data() {
        return {
            tops: [],
            dicts: {
                countries: [],
                deviceTypes: []
            },
            form: {
                name: '',
                countries: [],
                deviceTypes: []
            },
            selected: {},
            page: 1,
            pageSize: 25,
            pagesTotal: 1
        };
    },
    components: {
        SweetModal,
        SweetModalTab,
        vSelect
    },
    methods: {
        loadData() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            this.axios
                .all([
                    this.axios.get('tops-epc', {
                        params: {
                            searchPattern: this.form.name,
                            countries: this.form.countries.map((c) => c.id),
                            deviceTypes: this.form.deviceTypes.map((d) => d.id),
                            page: this.page,
                            size: this.pageSize
                        }
                    }),
                    this.axios.get('tops-epc/count'),
                    this.axios.get('tops-epc/dicts', { onlyActive: false })
                ])
                .then(
                    axios.spread((tops, count, dicts) => {
                        this.tops = tops.data;
                        this.pagesTotal = Math.floor(count.data / this.pageSize) + 1;
                        this.setDictionaries(dicts.data);
                    })
                )
                .catch((err) => {
                    this.$vs.notify({
                        title: 'Ошибка!',
                        text: 'Ошибка загрузки топов.',
                        color: 'danger'
                    });
                })
                .finally(() => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                });
        },
        loadTops() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            var params = {
                searchPattern: this.form.name,
                countries: this.form.countries.map((c) => c.id),
                deviceTypes: this.form.deviceTypes.map((d) => d.id),
                page: this.page,
                size: this.pageSize
            };

            this.axios
                .all([
                    this.axios.get('tops-epc', {
                        params: params,
                        paramsSerializer: (params) => {
                            return qs.stringify(params);
                        }
                    }),
                    this.axios.get('tops-epc/count', {
                        params: params,
                        paramsSerializer: (params) => {
                            return qs.stringify(params);
                        }
                    })
                ])
                .then(
                    axios.spread((tops, count) => {
                        this.tops = tops.data;
                        this.pagesTotal = Math.floor(count.data / this.pageSize) + 1;
                    })
                )
                .catch((err) => {
                    this.$vs.notify({
                        title: 'Ошибка!',
                        text: 'Ошибка загрузки топов.',
                        color: 'danger'
                    });
                })
                .finally(() => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                });
        },
        checkAllSelection(dict, selected) {
            if (dict.length - 1 == selected.length) {
                return [{ id: -1, name: 'Все' }];
            }
            return selected;
        },
        setSelected(values, key) {
            if (values) {
                var lastOption = values[values.length - 1];
                if (lastOption && lastOption.id == -1) {
                    this.form[key] = [lastOption];
                } else {
                    const alloption = values.find((c) => c.id === -1);
                    if (alloption) {
                        this.form[key] = values.filter((c) => c.id !== -1);
                    }
                }
            }
        },
        setDictionaries(dicts) {
            this.dicts.adTypes = dicts.adTypes;

            const dictCountries = [{ id: -1, name: 'Все страны' }];
            dicts.countries.forEach((c) => {
                dictCountries.push(c);
            });
            this.dicts.countries = dictCountries;

            const dictDevices = [{ id: -1, name: 'Все платформы' }];
            dicts.deviceTypes.forEach((b) => {
                dictDevices.push(b);
            });
            this.dicts.deviceTypes = dictDevices;
        },
        createTop() {
            this.$router.push('/epc/create');
        },
        showDeleteModal(top) {
            this.selected = top;
            this.$refs.deleteModal.open();
        },
        deleteTop(top) {
            this.$axios({
                method: 'DELETE',
                url: 'tops-epc/' + top.id,
                errors: this.errors,
                success: () => {
                    this.tops = this.tops.filter((c) => c.id != top.id);
                    this.$refs.deleteModal.close();
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.$vs.notify({
                        title: 'Успешно удалено',
                        text: 'Топ успешно удален.',
                        color: 'success'
                    });
                },
                catch: (err) => {
                    this.$refs.deleteModal.close();
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    return this.$vs.notify({
                        title: 'Внимание!',
                        text: 'Ошибка при удалении топа!',
                        color: 'danger'
                    });
                }
            });
        },
        handleSort(key, active) {},
        handleSearch(searching) {}
    },
    watch: {
        page: function () {
            this.loadTops();
        }
    },
    mounted() {
        this.loadData();
    }
};
</script>

<style lang="scss">
table {
    tr.selected {
        cursor: text !important;
    }
    tr > td.actions {
        white-space: nowrap;
    }
}
thead {
    th {
        font-size: 15px !important;

        .sort-th {
            i {
                font-size: 19px;
            }
        }
    }
}
</style>
